import { isWebClient } from './detection';

export function refreshClient() {
  if (isWebClient() && window.location) {
    window.location.reload();
  }
}